<div class="preview-layout" [class.expanded]="expanded">
    <div class="preview-content">
        @for (error of downloadErrors; track $index) {
            <nz-alert nzType="error" nzShowIcon [nzMessage]="error"></nz-alert>
        }
        <cl-file-viewer
            [class.expanded]="expanded"
            [fileName]="previewData.fileName"
            [loadFileMetadata]="previewData.loadFileMetadata"
        ></cl-file-viewer>
    </div>
    <div class="modal-footer preview-actions">
        <button type="button" nz-button [attr.aria-pressed]="expanded" (click)="toggleExpanded()">{{ expanded ? 'Atjaunot' : 'Palielināt' }}</button>
        <button type="button" nz-button [nzLoading]="downloadLoading" (click)="download()">
            <span nz-icon nzType="download"></span>
            Lejupielādēt
        </button>
        <button type="button" nz-button (click)="close()">Aizvērt</button>
    </div>
</div>
